import { Heading } from "@ariakit/react";
import { Link } from "wouter";
import { href } from "../App/href.tsx";
import gravehelm from "./gravehelmLogo.svg";
import { banner } from "./style.css.ts";

export function NewsBanner(props: {
  heading: string;
  text: string;
  href: string;
  imageSrc?: string;
}) {
  const { heading, text, href } = props;

  return (
    <Link className={banner.container} href={href}>
      <div className={banner.content}>
        <Heading className={banner.heading}>
          <img
            src={gravehelm}
            alt={heading}
            style={{ blockSize: "1.25rem", inlineSize: "auto" }}
          />
        </Heading>

        <p className={banner.text}>{text}</p>
      </div>
    </Link>
  );
}

/**
 * Update this to announce something new. Bump `publishedAt` so that users who
 * dismissed a previous banner will see the new one.
 */
export function GravehelmBanner() {
  return (
    <NewsBanner
      heading="Gravehelm"
      text="A free spooky scenario and lore pack for Greathelm. Includes limited edition STL sets by Skullforge and Finsterfey Miniatures."
      href={href("~/gravehelm")}
    />
  );
}
